import serialNumberToOrder from './serialNumberToOrder.vue'
export default serialNumberToOrder
